module.exports = __webpack_public_path__ + "img/土木香.6b817996.jpg";